<template>
  <div @click="$emit('click')">
    <el-card :id="`${team1}-v-${team2}`">
      <!-- FOR FEED BUTTON  -->
      <slot />
      <div class="match-title">
        <p>
          <strong> {{ comp }} </strong>
        </p>
        <p>{{ title }}</p>
      </div>
      <div class="versus-wrapper">
        <div class="versus">
          <div class="team" @click="$emit('open_team', { team: match.homeTeam, match })">
            <div class="club-logo">
              <img :src="getS3URL(club1._id)" @error="displayPlaceholder" :alt="team1" />
            </div>
            <div class="team-name left">
              <span>{{ team1 }}</span>
            </div>
          </div>
          <div class="time-wrap">
            <div class="scores d-flex">
              <div class="score">
                <component
                  class="font-22"
                  :is="parseInt(score1) > parseInt(score2) ? 'b' : 'span'"
                  >{{ score1 }}</component
                >
              </div>
              <div class="caps grey">
                {{ time }}
                <br />
                {{ gameState ? gameState : status }}
              </div>
              <div class="score">
                <component
                  class="font-22"
                  :is="parseInt(score2) > parseInt(score1) ? 'b' : 'span'"
                  >{{ score2 }}</component
                >
              </div>
            </div>
          </div>
          <div class="team" @click="$emit('open_team', { team: match.awayTeam, match })">
            <div class="club-logo">
              <img :src="getS3URL(club2._id)" @error="displayPlaceholder" :alt="team2" />
            </div>
            <div class="team-name right">
              <span>{{ team2 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="match-title">{{ place || "NA" }} {{ fieldNo ? `, Field ${fieldNo}` : "" }}</div>
    </el-card>
  </div>
</template>
<script>
import dayjs from "@/utils/dayjs";
import { getS3URL } from "../utils/utilities";
import { EventBus } from "../bus";

export default {
  name: "Match",
  props: ["match"],
  data() {
    return {
      getS3URL
    };
  },
  mounted() {
    EventBus.$on("gamestate/update", () => {
      this.$forceUpdate();
    });
  },
  computed: {
    title() {
      return `Round ${this.match.round.number} ${this.matchDate(this.match.dateTime)}`;
    },
    comp() {
      return this.match.competition.name;
    },
    fieldNo() {
      return this.match.meta && this.match.meta.fieldNo ? this.match.meta.fieldNo : false;
    },
    team1() {
      if (this.match.meta && this.match.meta.isTba) return "TBA";
      return this.match.homeTeam ? this.match.homeTeam.name : "BYE";
    },
    club1() {
      return this.match.homeTeam && this.match.homeTeam.orgtree && this.match.homeTeam.orgtree.club
        ? this.match.homeTeam.orgtree.club
        : { _id: "" };
    },
    team2() {
      if (this.match.meta && this.match.meta.isTba) return "TBA";
      return this.match.awayTeam ? this.match.awayTeam.name : "BYE";
    },
    club2() {
      return this.match.awayTeam && this.match.awayTeam.orgtree && this.match.awayTeam.orgtree.club
        ? this.match.awayTeam.orgtree.club
        : { _id: "" };
    },
    time() {
      return this.matchTime(this.match.dateTime);
    },
    place() {
      return this.match.venue ? this.match.venue.name : "";
    },
    score1: {
      cache: false,
      get() {
        return this.match.scores.homeTeam;
      }
    },
    score2: {
      cache: false,
      get() {
        return this.match.scores.awayTeam;
      }
    },
    status() {
      return this.match.status;
    },
    gameState() {
      return this.match.gameStates && this.match.gameStates.length > 0
        ? this.match.gameStates.slice(-1)[0].name
        : undefined;
    }
  },
  methods: {
    displayPlaceholder(event) {
      event.target.src = require("../assets/shield_black.svg");
    },
    matchDate(dateTime) {
      return dayjs(dateTime).format("dddd Do MMMM");
    },
    matchTime(dateTime) {
      return dayjs(dateTime).format("h:mma");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 10px;
  padding-bottom: 2rem;
}
.grey {
  color: grey;
}
.versus-wrapper {
  display: flex;
}
.time-wrap {
  min-width: 100px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding: 30px;
  .scores {
    flex-grow: 1;
    justify-content: space-between;
    max-width: 150px;
    font-weight: normal;
  }
  @media (max-width: $sm) {
    font-size: 0.7em;
    padding: 1px;
  }
}

.versus {
  flex-grow: 1;
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  height: 80px;
}

.team {
  width: 24%;
  text-align: center;
}

.club-logo {
  width: 60px;
  margin: 0 auto;
  img {
    max-width: 100%;
    height: auto;
  }
}

.font-22 {
  font-size: 22px;
  @media (max-width: $sm) {
    width: 150px;
    font-size: 2em;
  }
}
.score {
  @media (max-width: $sm) {
    margin: 0px 0px;
    width: 20px;
  }
}

.team-name {
  @media (max-width: $sm) {
    font-size: 0.7em;
  }
}

.versus {
  font-weight: 500;
  display: flex;

  * {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.block {
  min-width: 50px;
}
.match-title {
  font-size: 0.7em;
  color: grey;
  text-align: center;
}
.caps {
  text-transform: uppercase;
  text-align: center;
}
</style>
